import { useMemo } from "react";

import { useLocation } from "react-router-dom";

import { styled } from "simplydo/react/styled";

import { useAppSelector } from "store";
import util from "utils/utils";

const StyledFooter = styled.div`
  background: #fff;
  padding: ${({ theme }) =>
    theme.sizes.isMobile ? "15px 50px 15px 50px" : "10px 10px 10px 10px"};
  z-index: 1;
  box-shadow:
    0px -2px 2px -1px rgba(0, 0, 0, 0.04),
    0px -1px 2px -1px rgba(0, 0, 0, 0.1) !important;
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
`;

function Footer() {
  const year = new Date().getFullYear();
  const location = useLocation();
  const ideaViewType = useAppSelector((state) => state.challenges.ideaViewType);

  const hideFooter = useMemo(
    () =>
      ideaViewType === "board" &&
      location.pathname.match(/^\/challenges\/[a-f\d]{24}\/ideas$/),
    [ideaViewType, location.pathname],
  );

  if (hideFooter) {
    return null;
  }
  return (
    <StyledFooter>
      <div>
        <span
          style={{
            display: "block",
            fontSize: 10,
            fontWeight: 300,
            textTransform: "uppercase",
          }}
        >
          Innovation powered by
        </span>
        <span style={{ display: "block", fontSize: 14 }}>
          {util.appName()}{" "}
          <span
            style={{
              textTransform: "uppercase",
              fontSize: 8,
              color: "rgb(170,170,170)",
            }}
          >
            Version {import.meta.env.VITE_GIT_SHA}
          </span>
        </span>
        <span style={{ display: "block", fontSize: 10, fontWeight: 300 }}>
          &copy; {year} Simply Do Ideas Limited
        </span>
      </div>

      <div>
        <span style={{ fontSize: 10, marginLeft: 10 }}>
          <a
            href="https://simplydo.co.uk/terms-of-use"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Use
          </a>{" "}
          -{" "}
          <a
            href="https://simplydo.co.uk/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </span>
      </div>
    </StyledFooter>
  );
}

export default Footer;
